import crudActions from '@/store/crudActions'

export default crudActions('certificate-types')
